import { render, staticRenderFns } from "./ModalPersonDocument.vue?vue&type=template&id=5958c2a2&scoped=true&"
import script from "./ModalPersonDocument.vue?vue&type=script&lang=js&"
export * from "./ModalPersonDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalPersonDocument.vue?vue&type=style&index=0&id=5958c2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5958c2a2",
  null
  
)

export default component.exports